
import { useState, useEffect } from "react";
import Header from "../Components/Header";
import HeroSection from "../Components/HeroSection";
import TitleContent from "../Components/TitleContent";
import Footer from "../Components/Footer";
import BackgroundGradient from "../Images/BackgroundGradient.png";
import BackgroundGradientSmall from "../Images/BackgroundGradientSmall.png";
import { quantumRNDProducts } from "../Data/Products";
import { BoxHover } from "../Components/BoxHover";


export default function ResearchandDevelopment() {
    const [backgroundImage, setBackgroundImage] = useState(``);

    useEffect(() => {
        const updateBackgroundImage = () => {
            if (window.innerWidth < 640) {
                setBackgroundImage(`url(${BackgroundGradientSmall})`);
            } else {
                setBackgroundImage(`url(${BackgroundGradient})`);
            }
        };

        // Set initial background image
        updateBackgroundImage();

        // Update background image on window resize
        window.addEventListener("resize", updateBackgroundImage);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener("resize", updateBackgroundImage);
    }, []);

    return (
      <div className="w-full  flex flex-col gap-0 items-center justify-center bg-primary7">
        <div
          className="w-full width flex flex-col gap-0 items-center justify-center bg-contain bg-repeat"
          style={{ backgroundImage: backgroundImage }}
        >
          <Header id={3} />

          <div className="w-full bg-primary7 flex flex-col items-center justify-center gap-6 ">
         
              <div className="w-full h-[25rem] ">
                <HeroSection
                  title1="Advancing Quantum Science"
                  title2="into Real-World Technologies"
                  content="Driving innovation at the intersection of quantum physics and engineering, our R&D focuses on building scalable, secure, and practical quantum solutions for the future."
                />
              </div>
              <div className="max-w-5xl  mx-auto px-8">
                <BoxHover items={quantumRNDProducts} />
              </div>
  

            <Footer showpage={false} />
          </div>
        </div>
      </div>
    );
}